import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateProductionLotAsyncImportJobMutationVariables = Types.Exact<{
  input: Types.CreateProductionLotAsyncImportJobInput;
}>;


export type CreateProductionLotAsyncImportJobMutation = { __typename?: 'Mutation', createProductionLotAsyncImportJob: { __typename?: 'AsyncImportJobPayload', asyncImportJob?: { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, status: Types.AsyncImportJobStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddProductionLotAsyncImportJobRowsMutationVariables = Types.Exact<{
  input: Types.AddProductionLotAsyncImportJobRowsInput;
}>;


export type AddProductionLotAsyncImportJobRowsMutation = { __typename?: 'Mutation', addProductionLotAsyncImportJobRows: { __typename?: 'AsyncImportJobPayload', asyncImportJob?: { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, totalRows: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type FinalizeImportUploadMutationVariables = Types.Exact<{
  input: Types.FinalizeImportUploadInput;
}>;


export type FinalizeImportUploadMutation = { __typename?: 'Mutation', finalizeImportUpload: { __typename?: 'AsyncImportJobPayload', asyncImportJob?: { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, status: Types.AsyncImportJobStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionLotAsyncImportJobRowsMutationVariables = Types.Exact<{
  input: Types.UpdateProductionLotAsyncImportJobRowsInput;
}>;


export type UpdateProductionLotAsyncImportJobRowsMutation = { __typename?: 'Mutation', updateProductionLotAsyncImportJobRows: { __typename?: 'AsyncImportJobPayload', asyncImportJob?: { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveImportRowsMutationVariables = Types.Exact<{
  input: Types.RemoveImportRowsInput;
}>;


export type RemoveImportRowsMutation = { __typename?: 'Mutation', removeImportRows: { __typename?: 'AsyncImportJobPayload', asyncImportJob?: { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, totalRows: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevalidateImportMutationVariables = Types.Exact<{
  input: Types.RevalidateImportInput;
}>;


export type RevalidateImportMutation = { __typename?: 'Mutation', revalidateImport: { __typename?: 'AsyncImportJobPayload', asyncImportJob?: { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, status: Types.AsyncImportJobStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateAsyncImportJobStatusMutationVariables = Types.Exact<{
  input: Types.UpdateAsyncImportJobStatusInput;
}>;


export type UpdateAsyncImportJobStatusMutation = { __typename?: 'Mutation', updateAsyncImportJobStatus: { __typename?: 'AsyncImportJobPayload', asyncImportJob?: { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, status: Types.AsyncImportJobStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateProductionLotAsyncImportJobDocument = new TypedDocumentString(`
    mutation CreateProductionLotAsyncImportJob($input: CreateProductionLotAsyncImportJobInput!) {
  createProductionLotAsyncImportJob(input: $input) {
    asyncImportJob {
      asyncImportJobId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const AddProductionLotAsyncImportJobRowsDocument = new TypedDocumentString(`
    mutation AddProductionLotAsyncImportJobRows($input: AddProductionLotAsyncImportJobRowsInput!) {
  addProductionLotAsyncImportJobRows(input: $input) {
    asyncImportJob {
      asyncImportJobId
      totalRows
    }
    errors {
      code
      message
    }
  }
}
    `);
export const FinalizeImportUploadDocument = new TypedDocumentString(`
    mutation FinalizeImportUpload($input: FinalizeImportUploadInput!) {
  finalizeImportUpload(input: $input) {
    asyncImportJob {
      asyncImportJobId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const UpdateProductionLotAsyncImportJobRowsDocument = new TypedDocumentString(`
    mutation UpdateProductionLotAsyncImportJobRows($input: UpdateProductionLotAsyncImportJobRowsInput!) {
  updateProductionLotAsyncImportJobRows(input: $input) {
    asyncImportJob {
      asyncImportJobId
    }
    errors {
      code
      message
    }
  }
}
    `);
export const RemoveImportRowsDocument = new TypedDocumentString(`
    mutation RemoveImportRows($input: RemoveImportRowsInput!) {
  removeImportRows(input: $input) {
    asyncImportJob {
      asyncImportJobId
      totalRows
    }
    errors {
      code
      message
    }
  }
}
    `);
export const RevalidateImportDocument = new TypedDocumentString(`
    mutation RevalidateImport($input: RevalidateImportInput!) {
  revalidateImport(input: $input) {
    asyncImportJob {
      asyncImportJobId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const UpdateAsyncImportJobStatusDocument = new TypedDocumentString(`
    mutation UpdateAsyncImportJobStatus($input: UpdateAsyncImportJobStatusInput!) {
  updateAsyncImportJobStatus(input: $input) {
    asyncImportJob {
      asyncImportJobId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateProductionLotAsyncImportJob: build.mutation<CreateProductionLotAsyncImportJobMutation, CreateProductionLotAsyncImportJobMutationVariables>({
      query: (variables) => ({ document: CreateProductionLotAsyncImportJobDocument, variables })
    }),
    AddProductionLotAsyncImportJobRows: build.mutation<AddProductionLotAsyncImportJobRowsMutation, AddProductionLotAsyncImportJobRowsMutationVariables>({
      query: (variables) => ({ document: AddProductionLotAsyncImportJobRowsDocument, variables })
    }),
    FinalizeImportUpload: build.mutation<FinalizeImportUploadMutation, FinalizeImportUploadMutationVariables>({
      query: (variables) => ({ document: FinalizeImportUploadDocument, variables })
    }),
    UpdateProductionLotAsyncImportJobRows: build.mutation<UpdateProductionLotAsyncImportJobRowsMutation, UpdateProductionLotAsyncImportJobRowsMutationVariables>({
      query: (variables) => ({ document: UpdateProductionLotAsyncImportJobRowsDocument, variables })
    }),
    RemoveImportRows: build.mutation<RemoveImportRowsMutation, RemoveImportRowsMutationVariables>({
      query: (variables) => ({ document: RemoveImportRowsDocument, variables })
    }),
    RevalidateImport: build.mutation<RevalidateImportMutation, RevalidateImportMutationVariables>({
      query: (variables) => ({ document: RevalidateImportDocument, variables })
    }),
    UpdateAsyncImportJobStatus: build.mutation<UpdateAsyncImportJobStatusMutation, UpdateAsyncImportJobStatusMutationVariables>({
      query: (variables) => ({ document: UpdateAsyncImportJobStatusDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateProductionLotAsyncImportJobMutation, useAddProductionLotAsyncImportJobRowsMutation, useFinalizeImportUploadMutation, useUpdateProductionLotAsyncImportJobRowsMutation, useRemoveImportRowsMutation, useRevalidateImportMutation, useUpdateAsyncImportJobStatusMutation } = injectedRtkApi;
